import { getUrl } from 'app/UrlService'
import { StepTypes } from 'data/hooks/actionTypes'

export function getActionNavigateToTarget(
    action: ActionDto | undefined,
    record: RecordDto | undefined,
    views: ViewDto[],
    objects: ObjectDto[]
) {
    const linkTarget = action?.options?.steps.find(
        (step) => step.type === StepTypes.NavigateTo && !!step.navigateTo
    )?.navigateTo
    const linkTargetType = linkTarget?.type

    let url: string | undefined = undefined
    switch (linkTargetType) {
        case 'url':
            url = (linkTarget as ActionStepNavigateToUrl)?.href
            url = url ? encodeURI(url) : undefined
            break
        case 'field': {
            const fieldApiName = (linkTarget as ActionStepNavigateToField)?.fieldApiName ?? ''
            const urlValue = record?.[fieldApiName] ?? undefined
            url = extractUrlFromValue(urlValue)
            url = url ? encodeURI(url) : undefined
            break
        }
        case 'view':
            const { viewSid = '', objectSid } = (linkTarget as ActionStepNavigateToView) ?? {}
            url = getViewUrl(viewSid, objectSid || null, views, objects)
            break
    }

    const shouldHide = !linkTarget || !url

    const openAs = linkTarget?.openAs
    const target = openAs === 'new_tab' ? '_blank' : undefined

    const isUrlRelative = url?.startsWith('/')

    return {
        isNavigationTarget: !!linkTarget,
        url,
        shouldHide,
        target,
        isUrlRelative,
        openAs,
    }
}

function extractUrlFromValue(value: unknown) {
    // String type.
    if (typeof value === 'string') {
        return value
    }

    // multi_file type.
    if (Array.isArray(value)) {
        const firstAttachment = value[0]
        if (firstAttachment && typeof firstAttachment === 'object' && 'url' in firstAttachment) {
            return firstAttachment.url
        }
    } else if (value && typeof value === 'object' && 'url' in value) {
        return value.url
    }

    return undefined
}

function getViewUrl(
    viewSid: string,
    objectSid: string | null,
    views: ViewDto[],
    objects: ObjectDto[]
): string | undefined {
    const view = views.find((v) => v._sid === viewSid && v.object_id === objectSid)
    if (!view) return undefined

    if (view.type === 'create') {
        const object = objects.find((o) => o._sid === objectSid)
        if (!object) return undefined

        return getUrl(`${object.url}/new`)
    }

    return getUrl(view.url)
}
